import classnames from "classnames";
import styles from "@/styles/ScrollMenu.module.scss";

export default function ScrollMenu({ className, children }) {
  return (
    <div className={styles.container}>
      <div className={classnames(styles.menu, className)}>{children}</div>
    </div>
  );
}
